import dynamic from 'next/dynamic';
import i18n from '@/settings/i18n';
import Loading from '@/components/commons/Loading';

const t = i18n.init('buyback');

const BuybackWidget = dynamic(() => import('./TradeInWidget'), {
  ssr: false,
  // Matches the US widget's own loading state. The third-party widgets resize
  // themselves once their script runs, which can't be reserved from here.
  loading: () => (
    <div className="flex items-center justify-center py-24">
      <Loading />
    </div>
  ),
});

const TradeIn = () => (
  <div className="reebelo-container mt-5 pb-5">
    <p className="mb-5 text-center text-sm lg:text-base">
      {t`Choose the device you'd like to sell below.`}
    </p>
    <BuybackWidget />
  </div>
);

export default TradeIn;
